import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import CustomersList from './components/CustomersList';
import CustomerDetail from './components/CustomerDetail';

interface ICustomersLayoutProps {
  appReady: boolean;
  match: any;
}
export default class CustomersLayout extends React.Component<ICustomersLayoutProps> {
  static defaultProps: ICustomersLayoutProps = {
    appReady: false,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="customer-app" match={this.props.match}>
        <Route
          exact
          path={['/customers', '/', '/customers\\::filterConfig']}
          render={(): React.ReactNode => <CustomersList {...this.props} />}
        />
        <Route
          path="/customers/detail/:customerId"
          render={(): React.ReactNode => <CustomerDetail {...this.props} />}
        />
        {/* <PersonCreate
          toggleModal={this.props.people.showAddPerson}
          togglePersonCreateModal={this.props.actions.togglePersonCreateModal}
          {...this.props}
        /> */}
      </RenderContent>
    );
  }
}
